//login
export const title_login = "로그인";
export const email = "이메일";
export const password = "비밀번호";
export const save_email = "이메일 저장";
export const login = "로그인";
export const register = "회원가입";
export const auto_login = "자동 로그인";
export const confirm = "확인";
export const ignore = "다시 보지 않기";
export const msg_admin_must = "관리자만 이용할 수 있습니다.";

export const msg_pwd_must = "비밀번호를 입력해 주세요.";
export const msg_pwd_min = "8자 이상 입력하셔야 합니다.";
export const msg_pwd_max = "20자까지만 입력할 수 있습니다.";
export const msg_pwd_rule = "8~20자 영문 대 소문자, 숫자, 특수문자를 입력해 주세요.";

export const title_find_id = "ID 찾기";
export const name = "이름";
export const msg_name_must = "이름을 입력해 주세요.";
export const msg_name_max = "최대 50자까지 입력할 수 있습니다.";

export const title_reset_password = "비밀번호 재설정";
export const msg_email_must = "이메일을 입력해 주세요.";
export const msg_email_rule = "이메일 형식에 맞지 않는 메일 주소입니다.";
export const msg_email_max = "최대 64자까지 입력할 수 있습니다.";

export const msg_company_registration_no_must = "사업자 등록번호를 입력해 주세요.";
export const msg_company_registration_no_rule = "유효하지 않은 사업자 등록번호입니다.";
export const msg_company_registration_no_only_number = "숫자만 입력해주세요.";

export const dash = "-";
export const cancellationComplete = "취소 완료";
export const useComplete = "이용 완료";
export const reservationComplete = "예약 완료";

export const count_car = "대";
export const totalRentCarCount = "렌트 차량 수";
export const totalActiveRentCarCount = "운영 차량 수";
export const totalRepairingRentCarCount = "점검 차량 수";
export const totalWaitingRentCarCount = "대기 차량 수";

export const rent_use = "출차";
export const rent_cancel_use = "취소";
export const rent_return = "반납";
export const rent_arrive = "도착";

export const prev = "이전";
export const update = "저장";
export const edit = "수정";

export const online = "카드결제(온라인)";
export const offline_card = "카드결제(현장)";
export const offline_bank = "계좌이체(현장)";
export const offline_cash = "현금결제(현장)";
